import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const highlightingInfosResolver: FieldResolver = (metadata: Metadata) =>
  ({ highlightingInfos: metadata.getHighlightingInfos() } as StreamData)

export default highlightingInfosResolver
